export enum PaymentStatusView {
  Success = 'success',
  Cancel = 'cancel',
  Dispute = 'dispute',
  Processing = 'processing',
  NoRequisites = 'no_requisites',
  AssignAttempts = 'assign_attempts',
}
